import { render, staticRenderFns } from "./FullScreenSelect.vue?vue&type=template&id=879a958e&scoped=true&"
import script from "./FullScreenSelect.vue?vue&type=script&lang=js&"
export * from "./FullScreenSelect.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenSelect.vue?vue&type=style&index=0&id=879a958e&prod&lang=scss&"
import style1 from "./FullScreenSelect.vue?vue&type=style&index=1&id=879a958e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879a958e",
  null
  
)

export default component.exports